module.exports = __webpack_public_path__ + "img/code-projects.108cc531.jpg";